import React from "react";
// import { ScrollToTop } from 'components/formElements'
import styles from "./Footer.module.scss";

const Footer = () => (
  <footer className={styles.footer}>
    {/* <div className={styles.info}>
            <h3>Make a Difference to your life with Us</h3>
            <p>
                Discover various job Opportunities at Mindfire and let your true
                passion flow with work life balance and exciting benefits to
                take your life above the fold.
            </p>
            <button>Apply For Job</button>
        </div> */}
    <div className={styles.copyright}>
      <p className={styles.copyrightContent}>
        &copy; {new Date().getFullYear()} - Mindfire Solutions. All rights
        reserved.
      </p>
    </div>
    {/* <ScrollToTop /> */}
  </footer>
);

export { Footer };
